<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<span class="p-float-label">
  <p-dropdown [options]="ruAccounts" [(ngModel)]="ruAccount" (onChange)="onRUAccount($event)"
    optionLabel="name" optionValue="value" [filter]="false"
    [showClear]="false" placeholder="Select RU Account">
  </p-dropdown>
  <label for="ruAccount">Select RU Account</label>
  <!-- <span *ngFor="let validation of validationMessages.ruAccount">
  <small id="developmentId-help" class="p-invalid"
    *ngIf="form1.get('ruAccount').hasError(validation.type) && (form1.get('ruAccount').dirty || form1.get('ruAccount').touched)">{{validation.message}}
  </small>
</span> -->
</span>

<div class="pl-4 pr-4" [formGroup]="form1">
  <p-fieldset styleClass="p-fluid " legend="Add Building" [toggleable]="true" [collapsed]="true">
    <div class="p-formgrid grid">
      <div class="col-12">
        Add a development to Rental United.
      </div>

      <div class="p-field col-12 mt-6">
        <span class="p-float-label">
          <p-dropdown [options]="developments" formControlName="developmentId" optionLabel="addressDevelopmentName" optionValue="developmentId" [filter]="true" filterBy="addressDevelopmentName"
          [showClear]="false" placeholder="Select Development"></p-dropdown>
          <label for="developmentId">Select Development</label>
          @for (validation of validationMessages.developmentId; track validation) {
            <span>
              @if (form1.get('developmentId').hasError(validation.type) && (form1.get('developmentId').dirty || form1.get('developmentId').touched)) {
                <small id="developmentId-help" class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>


      <div class="p-field col-12 mt-3">
        <span class="p-float-label">
          <input formControlName="addressDevelopmentName" id="addressDevelopmentName" type="text" pInputText>
          <label for="addressDevelopmentName">Building Name</label>
          @for (validation of validationMessages.addressDevelopmentName; track validation) {
            <span>
              @if (form1.get('addressDevelopmentName').hasError(validation.type) && (form1.get('addressDevelopmentName').dirty || form1.get('addressDevelopmentName').touched)) {
                <small id="addressDevelopmentName-help" class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="flex justify-content-end mt-3">
        @if (formErrorMessage) {
          <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
        }
        <br>
          <button pButton type="button" label="Add Building" (click)="onFormSubmit()"></button>
        </div>
      </div>
    </p-fieldset>


    <br>
      <br>

        <h2>Buildings</h2>
        <p-table [value]="buildings">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="BuildingID">BuildingID <p-sortIcon field="BuildingID"></p-sortIcon>
            </th>
            <th pSortableColumn="BuildingName">BuildingName <p-sortIcon field="BuildingName"></p-sortIcon>
          </th>
          <th pSortableColumn="PropertyIDs">PropertyIDs <p-sortIcon field="PropertyIDs"></p-sortIcon>
        </th>

      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-building>
      <tr>
        <td>{{building.BuildingID}}</td>
        <td>{{building.BuildingName}}</td>
        <td>
          @for (id of building.PropertyID; track id) {
            <div> {{id}}<br></div>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
